// Generated by scripts/generate-mingcute-line-icon-catalog.ts. Do not edit.

export const mingcuteLineIconKeys = [
  'abs',
  'ad-circle-off',
  'ad-circle',
  'ad-rectangle-off',
  'ad-rectangle',
  'add-circle-dash',
  'add-circle',
  'add-square',
  'add',
  'aerial-lift',
  'ai',
  'aiming-2',
  'aiming',
  'air-balloon',
  'air-condition-open',
  'air-condition',
  'airbnb',
  'airdrop',
  'airplane',
  'airplay',
  'airpods-2',
  'airpods',
  'alarm-1',
  'alarm-2',
  'album-2',
  'album',
  'alert-diamond',
  'alert-octagon',
  'alert',
  'align-arrow-down',
  'align-arrow-left',
  'align-arrow-right',
  'align-arrow-up',
  'align-bottom',
  'align-center',
  'align-horizontal-center',
  'align-justify',
  'align-left-2',
  'align-left',
  'align-right-2',
  'align-right',
  'align-top',
  'align-vertical-center',
  'alipay',
  'american-football',
  'anchor',
  'and',
  'android-2',
  'android',
  'angel',
  'angry',
  'anniversary',
  'announcement',
  'anticlockwise-alt',
  'anticlockwise',
  'apple-fruit',
  'apple-intelligence-frame',
  'apple-intelligence',
  'apple',
  'appstore',
  'aquarius',
  'arc-browser',
  'archive',
  'aries',
  'arrow-down-circle',
  'arrow-down',
  'arrow-left-circle',
  'arrow-left-down-circle',
  'arrow-left-down',
  'arrow-left-up-circle',
  'arrow-left-up',
  'arrow-left',
  'arrow-right-circle',
  'arrow-right-down-circle',
  'arrow-right-down',
  'arrow-right-up-circle',
  'arrow-right-up',
  'arrow-right',
  'arrow-to-down',
  'arrow-to-left',
  'arrow-to-right',
  'arrow-to-up',
  'arrow-up-circle',
  'arrow-up',
  'arrows-down',
  'arrows-left',
  'arrows-right',
  'arrows-up',
  'artboard',
  'aspect-ratio',
  'asterisk-2',
  'asterisk',
  'at',
  'attachment-2',
  'attachment-3',
  'attachment',
  'auction',
  'audio-tape',
  'auto-hold',
  'avalanche-avax',
  'award',
  'axe',
  'az-sort-ascending-letters',
  'az-sort-descending-letters',
  'baby-carriage',
  'baby',
  'back-2',
  'back',
  'backboard',
  'background',
  'backpack',
  'badge',
  'badminton',
  'balance',
  'balloon-2',
  'bank-card',
  'bank-of-china-tower',
  'bank',
  'barbell',
  'barcode-scan',
  'barcode',
  'base-station-2',
  'base-station',
  'baseball-2',
  'baseball',
  'basket-2',
  'basket',
  'basketball',
  'bath',
  'battery-1',
  'battery-2',
  'battery-3',
  'battery-4',
  'battery-automotive',
  'battery-charging',
  'battery',
  'beachball',
  'bear',
  'beard',
  'bed-2',
  'bed',
  'bedside-table-2',
  'bedside-table',
  'behance',
  'bell-ringing',
  'big-ben',
  'bike',
  'bilibili',
  'bill-2',
  'bill',
  'binance-coin-bnb',
  'binance-usd-busd',
  'bird',
  'birthday-2',
  'black-board-2',
  'black-board',
  'blessing',
  'bling',
  'blockquote',
  'bluesky-social',
  'bluetooth-off',
  'bluetooth',
  'bnb',
  'board',
  'body',
  'bold',
  'bomb',
  'bone',
  'book-2-ai',
  'book-2',
  'book-3',
  'book-4',
  'book-5',
  'book-6-ai',
  'book-6',
  'book-ai',
  'book',
  'bookmark-add',
  'bookmark-edit',
  'bookmark-remove',
  'bookmark',
  'bookmarks',
  'boom',
  'border-blank',
  'border-bottom',
  'border-horizontal',
  'border-inner',
  'border-left',
  'border-outer',
  'border-radius',
  'border-right',
  'border-top',
  'border-vertical',
  'bottle-glass',
  'bottle',
  'bow-tie',
  'bowknot',
  'bowl-2',
  'bowl',
  'box-2',
  'box-3',
  'box-4',
  'box',
  'braces',
  'brackets-angle',
  'brackets',
  'brain',
  'brake',
  'bread',
  'bridge-2',
  'bridge',
  'brief',
  'briefcase-2',
  'briefcase',
  'brightness',
  'broom',
  'brush-2-ai',
  'brush-2',
  'brush-3-ai',
  'brush-3',
  'brush',
  'bubble',
  'bug',
  'building-1',
  'building-2',
  'building-3',
  'building-4',
  'building-5',
  'building-6',
  'bulb-2-ai',
  'bulb-2',
  'bulb-ai',
  'bulb',
  'burj-al-arab',
  'burj-khalifa-tower',
  'bus-2',
  'bus',
  'butterfly-2',
  'butterfly',
  'button',
  'cactus-2',
  'cactus',
  'cake',
  'calendar-2',
  'calendar-3',
  'calendar-add',
  'calendar-day',
  'calendar-month',
  'calendar-time-add',
  'calendar-week',
  'calendar-x',
  'calendar',
  'camcorder-2',
  'camcorder-3',
  'camcorder-ai',
  'camcorder-off',
  'camcorder',
  'camera-2-ai',
  'camera-2-off',
  'camera-2',
  'camera-rotate',
  'camera',
  'campfire',
  'campground',
  'cancer',
  'candle',
  'candles',
  'candy-2',
  'candy',
  'canton-tower',
  'capricorn',
  'capsule',
  'car-2',
  'car-3',
  'car-door',
  'car-window',
  'car',
  'card-pay',
  'card-refund',
  'cardano-ada',
  'cardboard-vr',
  'carplay',
  'carrot',
  'cash-2',
  'cash',
  'cat',
  'ceiling-lamp',
  'celebrate',
  'cellphone-2-ai',
  'cellphone-2-horizontal',
  'cellphone-2',
  'cellphone-vibration',
  'cellphone',
  'celsius',
  'certificate-2',
  'certificate',
  'champagne',
  'charging-pile',
  'chart-bar-2',
  'chart-bar',
  'chart-decrease',
  'chart-horizontal-2',
  'chart-horizontal',
  'chart-line',
  'chart-pie-2',
  'chart-pie-3',
  'chart-pie',
  'chart-vertical-2',
  'chart-vertical',
  'chat-1-ai',
  'chat-1',
  'chat-2-ai',
  'chat-2',
  'chat-3-ai',
  'chat-3',
  'chat-4-ai',
  'chat-4',
  'check-2',
  'check-circle-dash',
  'check-circle',
  'check',
  'checkbox',
  'checks',
  'chef-hat',
  'chess',
  'chicken',
  'chines-knot',
  'chip',
  'choice',
  'chopsticks',
  'christ-the-redeemer',
  'christmas-ball',
  'christmas-hat',
  'chrome',
  'church',
  'circle-dash',
  'clapperboard',
  'classify-2-ai',
  'classify-2',
  'classify-3-ai',
  'classify-3',
  'classify-add-2',
  'classify-add',
  'classify-ai',
  'classify',
  'claude',
  'clipboard',
  'clock-2',
  'clock',
  'clockwise-alt',
  'clockwise',
  'close-circle-dash',
  'close-circle',
  'close-medium',
  'close-small',
  'close-square',
  'close',
  'cloud-2',
  'cloud-lightning',
  'cloud-snow',
  'cloud-windy',
  'cloud',
  'clouds',
  'clubs',
  'coat',
  'coathanger',
  'code',
  'codepen',
  'coin-2',
  'coin-3',
  'coin',
  'color-filter',
  'color-picker',
  'column',
  'columns-2',
  'columns-3',
  'combine',
  'command',
  'comment-2',
  'comment',
  'compass-2',
  'compass-3',
  'compass',
  'components',
  'computer-camera-off',
  'computer-camera',
  'computer',
  'confused',
  'contacts-2',
  'contacts-3',
  'contacts-4',
  'contacts',
  'content-ai',
  'cookie-man',
  'cookie',
  'cooldown',
  'copilot',
  'copper-coin',
  'copy-2',
  'copy-3',
  'copy',
  'copyright',
  'corner-down-left',
  'corner-down-right',
  'corner-up-left',
  'corner-up-right',
  'counter-2',
  'counter',
  'coupon',
  'cross-2',
  'cross',
  'crutch',
  'crystal-ball',
  'cube-3d',
  'cube',
  'cupcake',
  'currency-baht-2',
  'currency-baht',
  'currency-bitcoin-2',
  'currency-bitcoin',
  'currency-cny-2',
  'currency-cny',
  'currency-dollar-2',
  'currency-dollar',
  'currency-euro-2',
  'currency-euro',
  'currency-lira-2',
  'currency-lira',
  'currency-nigeria-2',
  'currency-nigeria',
  'currency-pound-2',
  'currency-pound',
  'currency-rubel-2',
  'currency-rubel',
  'currency-rupee-2',
  'currency-rupee',
  'currency-shekel-2',
  'currency-shekel',
  'currency-won-2',
  'currency-won',
  'cursor-2',
  'cursor-3',
  'cursor-text',
  'cursor',
  'curtain',
  'cylinder-2',
  'cylinder',
  'dandelion',
  'danmaku-off',
  'danmaku-on',
  'danmaku',
  'dashboard-2',
  'dashboard-3',
  'dashboard-4',
  'dashboard',
  'deepseek',
  'deer',
  'delete-2',
  'delete-3',
  'delete-back',
  'delete',
  'dental',
  'department',
  'desk-lamp-2',
  'desk-lamp',
  'desk',
  'device',
  'diamond-2',
  'diamond-square',
  'diamond',
  'diary',
  'dingtalk',
  'dinner',
  'direction-arrow',
  'direction-dot',
  'directions-2',
  'directions',
  'directory',
  'disabled-2',
  'disabled',
  'disc',
  'discord',
  'dish-cover',
  'display',
  'distribute-spacing-horizontal',
  'distribute-spacing-vertical',
  'dividing-line',
  'doc',
  'document-2',
  'document-3',
  'document',
  'documents',
  'dog',
  'dogecoin-doge',
  'donut',
  'door',
  'dot-circle',
  'dot-grid',
  'dots-vertical',
  'dots',
  'down-small',
  'down',
  'download-2',
  'download-3',
  'download',
  'dragonfly',
  'drawer-2',
  'drawer',
  'drawing-board',
  'dress',
  'dribbble',
  'drink',
  'drive',
  'drizzle',
  'drone',
  'drop',
  'dropbox',
  'dropdown',
  'drum',
  'dry',
  'dutch-windmill',
  'ear',
  'earth-2',
  'earth-3',
  'earth-4',
  'earth-latitude',
  'earth-longitude',
  'earth',
  'ease-in-control-point',
  'ease-in-out-control-point',
  'ease-in',
  'ease-out-control-point',
  'ease-out',
  'easy-in-out',
  'ebike',
  'edge',
  'edit-2-ai',
  'edit-2',
  'edit-3-ai',
  'edit-3',
  'edit-4',
  'edit',
  'egg-crack',
  'egg',
  'egyptian-pyramids',
  'eiffel-tower',
  'electric-cooker',
  'emergency-flashers',
  'emoji-2',
  'emoji',
  'empty-box',
  'engine',
  'enter-door',
  'entrance',
  'eraser-ai',
  'eraser',
  'escalator-down',
  'escalator-up',
  'ethereum',
  'exchange-baht',
  'exchange-bitcoin',
  'exchange-cny',
  'exchange-dollar',
  'exchange-euro',
  'exclude',
  'exit-door',
  'exit',
  'expand-player',
  'exposure',
  'external-link',
  'eye-2',
  'eye-close',
  'eye',
  'eyebrow',
  'eyeglass',
  'face-mask',
  'face',
  'facebook',
  'faceid',
  'factory-2',
  'factory',
  'fahrenheit',
  'fan-2',
  'fan-direction-down',
  'fan-direction-front',
  'fan-direction-up',
  'fan',
  'fast-forward',
  'fast-rewind',
  'father-christmas',
  'fault',
  'fax',
  'feeder',
  'female',
  'ferris-wheel',
  'figma',
  'figure',
  'file-ai',
  'file-certificate',
  'file-check',
  'file-code',
  'file-download',
  'file-export',
  'file-forbid',
  'file-import',
  'file-info',
  'file-locked',
  'file-more',
  'file-music',
  'file-new',
  'file-search',
  'file-security',
  'file-star',
  'file-unknown',
  'file-upload',
  'file-warning',
  'file-zip',
  'file',
  'film',
  'filter-2',
  'filter-3',
  'filter',
  'finger-love',
  'finger-press',
  'finger-rock',
  'finger-swipe',
  'finger-tap',
  'finger-victory',
  'fingerprint-2',
  'fingerprint',
  'fire',
  'firecracker',
  'firefox',
  'firework',
  'first-aid-kit',
  'fish',
  'fitness',
  'flag-1',
  'flag-2',
  'flag-3',
  'flag-4',
  'flame',
  'flash-circle',
  'flash',
  'flashlight',
  'flask-2',
  'flask-3',
  'flask',
  'flexibility',
  'flight-inflight',
  'flight-land',
  'flight-takeoff',
  'flip-horizontal',
  'flip-vertical',
  'floating-dust',
  'flower-2',
  'flower-3',
  'flower-4',
  'flower-5',
  'flower',
  'flowerpot',
  'fog',
  'fold-horizontal',
  'fold-vertical',
  'folder-2',
  'folder-3',
  'folder-check',
  'folder-delete',
  'folder-download',
  'folder-forbid',
  'folder-info',
  'folder-locked-2',
  'folder-locked',
  'folder-minus',
  'folder-more',
  'folder-open-2',
  'folder-open',
  'folder-security',
  'folder-star',
  'folder-upload',
  'folder-warning',
  'folder-zip',
  'folder',
  'folders',
  'folding-fan',
  'follow',
  'font-size',
  'font',
  'foot',
  'football',
  'forbid-circle',
  'fork-knife',
  'fork-spoon',
  'fork',
  'formula',
  'forward-2',
  'forward',
  'four-wheel-drive',
  'frame',
  'fridge',
  'fried-egg',
  'fries',
  'front-fog-lights',
  'front-windshield-defroster',
  'full-moon',
  'fullscreen-2',
  'fullscreen-exit-2',
  'fullscreen-exit',
  'fullscreen',
  'game-1',
  'game-2',
  'gas-station',
  'gemini',
  'gesture-unlock',
  'ghost',
  'gift-2',
  'gift-card',
  'gift',
  'git-branch-2',
  'git-branch',
  'git-commit',
  'git-compare',
  'git-lab',
  'git-merge-2',
  'git-merge',
  'git-pull-request-close',
  'git-pull-request',
  'github-2',
  'github',
  'glass-cup',
  'globe-2',
  'globe',
  'glove',
  'google-gemini',
  'google-play',
  'google',
  'government',
  'gradienter',
  'grass',
  'greatwall',
  'grid-2',
  'grid',
  'grok-2',
  'grok',
  'group-2',
  'group-3',
  'group',
  'guitar',
  'gumroad',
  'hail',
  'hair-2',
  'hair',
  'hamburger',
  'hammer',
  'hand-card',
  'hand-finger-2',
  'hand-finger',
  'hand-grab',
  'hand-heart',
  'hand-two-fingers',
  'hand',
  'hands-clapping',
  'happy',
  'hashtag',
  'hat-2',
  'hat',
  'haze',
  'head-ai',
  'head',
  'heading-1',
  'heading-2',
  'heading-3',
  'headphone-2',
  'headphone',
  'heart-crack',
  'heart-half',
  'heart-hand',
  'heart',
  'heartbeat-2',
  'heartbeat',
  'heavy-rain',
  'heavy-rainstorm',
  'heavy-snow',
  'heavy-snowstorm',
  'hemisphere-2',
  'hemisphere',
  'hexagon',
  'hexagons-2',
  'hexagons',
  'high-knees',
  'high-temperature',
  'high-voltage-power',
  'hight-beam-headlights',
  'hiking',
  'history-2',
  'history-anticlockwise',
  'history',
  'hoe',
  'home-1',
  'home-2',
  'home-3',
  'home-4',
  'home-5',
  'home-6',
  'home-7',
  'home-wifi',
  'homepod-mini',
  'homepod',
  'hood',
  'hop',
  'horn-2',
  'horn',
  'hospital',
  'hotel',
  'hotkey',
  'hours',
  'house-2',
  'house',
  'ice-cream-2',
  'ice-cream',
  'idcard',
  'imac',
  'inbox-2',
  'inbox',
  'incognito-mode',
  'indent-decrease',
  'indent-increase',
  'indoor-rowing',
  'information',
  'injection',
  'inspect',
  'instagram',
  'instrument',
  'intersect',
  'inventory',
  'invite',
  'ios',
  'italic',
  'jeep',
  'jump',
  'kakao-talk',
  'key-1',
  'key-2',
  'key-3',
  'key-4',
  'keyboard-2',
  'keyboard',
  'keyhole',
  'kingkey-100-tower',
  'kite',
  'knife',
  'ladder',
  'lantern-2',
  'lantern',
  'laptop-2',
  'laptop',
  'large-arrow-down',
  'large-arrow-left',
  'large-arrow-right',
  'large-arrow-up',
  'laugh',
  'laurel-wreath',
  'layer',
  'layers',
  'layout-10',
  'layout-11',
  'layout-2',
  'layout-3',
  'layout-4',
  'layout-5',
  'layout-6',
  'layout-7',
  'layout-8',
  'layout-9',
  'layout-bottom-close',
  'layout-bottom-open',
  'layout-bottom',
  'layout-grid',
  'layout-left',
  'layout-leftbar-close',
  'layout-leftbar-open',
  'layout-right',
  'layout-rightbar-close',
  'layout-rightbar-open',
  'layout-top-close',
  'layout-top-open',
  'layout-top',
  'layout',
  'leaf-2',
  'leaf-3',
  'leaf',
  'left-small',
  'left',
  'lemon-squeezy',
  'leo',
  'letter-spacing',
  'libra',
  'lie-down',
  'lifebuoy',
  'light-snow',
  'light',
  'lighthouse',
  'lightning',
  'line-app',
  'line-height',
  'line',
  'linear',
  'link-2',
  'link-3',
  'link',
  'linkedin',
  'linux',
  'lipstick',
  'list-check-2',
  'list-check-3',
  'list-check',
  'list-collapse',
  'list-expansion',
  'list-ordered',
  'list-search',
  'live-location',
  'live-photo',
  'live',
  'loading-2',
  'loading-3',
  'loading-4',
  'loading',
  'location-2',
  'location-3',
  'location',
  'lock',
  'lollipop',
  'look-down',
  'look-left',
  'look-right',
  'look-up',
  'lotus',
  'love',
  'low-beam-headlights',
  'low-temperature',
  'luggage',
  'lungs',
  'magic-1',
  'magic-2',
  'magic-3',
  'magic-hat-2',
  'magic-hat',
  'magnet',
  'mail-ai',
  'mail-open',
  'mail-send',
  'mail',
  'mailbox',
  'male',
  'map-2',
  'map-pin',
  'map',
  'maple-leaf',
  'marina-bay-sand',
  'mark-pen',
  'markdown',
  'markup',
  'mastercard',
  'mastodon',
  'maya-pyramids',
  'mcp',
  'medal',
  'medium',
  'meh',
  'menu',
  'message-1-ai',
  'message-1',
  'message-2-ai',
  'message-2',
  'message-3-ai',
  'message-3',
  'message-4-ai',
  'message-4',
  'messenger',
  'meta',
  'mic-2',
  'mic-ai',
  'mic-off',
  'mic',
  'mickeymouse',
  'microphone',
  'microscope',
  'middle-finger',
  'midi',
  'mind-map',
  'mingcute',
  'minimize',
  'miniplayer',
  'minus-circle-dash',
  'minus-circle',
  'minus-square',
  'mirror',
  'misskey',
  'miyajima-torii',
  'moai',
  'moderate-snow',
  'moment',
  'monero',
  'monitor',
  'monument',
  'moon-cloudy',
  'moon-fog',
  'moon-stars',
  'moon',
  'moonlight',
  'more-1',
  'more-2',
  'more-3',
  'more-4',
  'mortarboard',
  'mosaic',
  'mountain-2',
  'mountain',
  'mouse',
  'mouth',
  'move',
  'movie',
  'mqtt',
  'multiselect',
  'mushroom',
  'music-2-ai',
  'music-2',
  'music-3',
  'music',
  'na',
  'navigation',
  'necktie',
  'netease-music',
  'new-folder',
  'newdot',
  'news-2',
  'news',
  'nfc',
  'nintendo-switch',
  'nose',
  'notebook-2',
  'notebook',
  'notification-newdot',
  'notification-off',
  'notification',
  'notion',
  'numbers-09-sort-ascending',
  'numbers-09-sort-descending',
  'numbers-90-sort-ascending',
  'numbers-90-sort-descending',
  'nurse',
  'octagon',
  'oil',
  'omega',
  'omg',
  'open-door',
  'openai',
  'package-2',
  'package',
  'pad',
  'paint-2',
  'paint-brush-ai',
  'paint-brush',
  'paint',
  'palace',
  'palette-2',
  'palette-3',
  'palette',
  'panoramas',
  'paper-2',
  'paper',
  'parachute',
  'paragraph',
  'parentheses',
  'parfum',
  'park',
  'parking-lights',
  'parking',
  'partly-cloud-daytime',
  'partly-cloud-night',
  'passport',
  'paste',
  'paster',
  'pause-circle',
  'pause',
  'pavilion',
  'paw',
  'paypal',
  'pdf',
  'pen-2-ai',
  'pen-2',
  'pen-ai',
  'pen',
  'pencil-2-ai',
  'pencil-2',
  'pencil-3-ai',
  'pencil-3',
  'pencil-ai',
  'pencil-ruler',
  'pencil',
  'pentagon',
  'percentage',
  'performance',
  'perplexity',
  'phone-add',
  'phone-block',
  'phone-call',
  'phone-incoming',
  'phone-off',
  'phone-outgoing',
  'phone-success',
  'phone',
  'photo-album-2',
  'photo-album',
  'pic-2',
  'pic-ai',
  'pic',
  'pickax',
  'pig-money',
  'pig',
  'pin-2',
  'pin',
  'pingpong',
  'pinterest',
  'pinwheel-2',
  'pinwheel',
  'pisa-tower',
  'pisces',
  'pizza',
  'planet',
  'play-circle',
  'play-football',
  'play',
  'playground',
  'playlist-2',
  'playlist',
  'plugin-2',
  'plugin',
  'plus',
  'polkadot-dot',
  'polygon',
  'pot',
  'power',
  'ppt',
  'pray',
  'prescription',
  'presentation-1',
  'presentation-2',
  'presentation-3',
  'print',
  'process',
  'profile',
  'projector-screen',
  'projector',
  'pumpkin-lantern',
  'pumpkin',
  'puzzled',
  'qq',
  'qrcode-2',
  'qrcode',
  'quarter-circle-dash',
  'question-2',
  'question',
  'quill-pen-ai',
  'quill-pen',
  'quote-left',
  'quote-right',
  'rabbit',
  'radar-2',
  'radar',
  'radio',
  'radiobox',
  'rain',
  'rainbow',
  'rainstorm',
  'rake',
  'random',
  'rare-fog-lights',
  'react',
  'rear-windshield-defroster',
  'receive-money',
  'record-mail',
  'rectangle-vertical',
  'rectangle',
  'recycle',
  'red-packet-open',
  'red-packet',
  'reddit',
  'refresh-1',
  'refresh-2',
  'refresh-3',
  'refresh-4-ai',
  'refresh-4',
  'refresh-anticlockwise-1',
  'refund-cny',
  'refund-dollar',
  'registered',
  'remote-control',
  'remote',
  'repeat-one',
  'repeat',
  'report-forms',
  'report',
  'rest-area',
  'restore',
  'rewind-backward-10',
  'rewind-backward-15',
  'rewind-backward-30',
  'rewind-backward-5',
  'rewind-backward-square-10',
  'rewind-backward-square-15',
  'rewind-backward-square-30',
  'rewind-backward-square-5',
  'rewind-forward-10',
  'rewind-forward-15',
  'rewind-forward-30',
  'rewind-forward-5',
  'rewind-forward-square-10',
  'rewind-forward-square-15',
  'rewind-forward-square-30',
  'rewind-forward-square-5',
  'riding',
  'right-small',
  'right',
  'road',
  'roblox',
  'robot',
  'rocket-2',
  'rocket',
  'rose',
  'rotate-to-horizontal',
  'rotate-to-vertical',
  'rotate-x',
  'rotate-y',
  'round',
  'route',
  'router-modem',
  'rows-2',
  'rows-3',
  'rows-4',
  'rss-2',
  'rss',
  'rudder',
  'ruler',
  'run-treadmill',
  'run',
  'sad',
  'safari',
  'safe-alert',
  'safe-box',
  'safe-flash',
  'safe-lock',
  'safe-shield-2',
  'safe-shield',
  'safety-certificate',
  'sagittarius',
  'sailboat',
  'sale',
  'sandglass-2',
  'sandglass',
  'sandstorm',
  'save-2',
  'save',
  'scale',
  'scan-2',
  'scan',
  'scarf',
  'schedule',
  'school',
  'science',
  'scissors-2',
  'scissors-3',
  'scissors',
  'scooter',
  'scorpio',
  'screenshot',
  'screwdriver',
  'scrollable-list',
  'seal',
  'search-2-ai',
  'search-2-none',
  'search-2',
  'search-3-ai',
  'search-3',
  'search-ai',
  'search-none',
  'search',
  'seat-heated',
  'seat',
  'section',
  'sector',
  'selector-horizontal',
  'selector-vertical',
  'semicircle-dash',
  'send-plane',
  'send',
  'server-2',
  'server',
  'service',
  'settings-1',
  'settings-2',
  'settings-3',
  'settings-4',
  'settings-5',
  'settings-6',
  'settings-7',
  'shadow',
  'share-2',
  'share-3',
  'share-forward',
  'shield-shape',
  'shield',
  'ship',
  'shirt',
  'shoe-2',
  'shoe',
  'shop',
  'shopping-bag-1',
  'shopping-bag-2',
  'shopping-bag-3',
  'shopping-cart-1',
  'shopping-cart-2',
  'shorts',
  'shovel',
  'shower-gel',
  'shower',
  'showers',
  'shuffle-2',
  'shuffle',
  'sick',
  'signal',
  'signature-2-ai',
  'signature-2',
  'signature',
  'silent',
  'siri-frame',
  'siri',
  'sitemap',
  'skateboard',
  'skateboarding',
  'skip-forward',
  'skip-previous',
  'skirt',
  'skull',
  'sleep',
  'sleigh',
  'snapchat',
  'snow',
  'snowboarding',
  'snowflake',
  'snowman',
  'snowstorm-2',
  'snowstorm',
  'sob',
  'social-x',
  'sock',
  'sofa',
  'solana-sol',
  'solar-panel',
  'sort-ascending',
  'sort-descending',
  'sound-line',
  'soup-pot-2',
  'soup-pot',
  'space',
  'spacing-horizontal',
  'spacing-vertical',
  'spade',
  'sparkles-2',
  'sparkles-3',
  'sparkles',
  'spatula',
  'speaker',
  'speech',
  'spoon',
  'spotify',
  'square-arrow-down',
  'square-arrow-left',
  'square-arrow-right',
  'square-arrow-up',
  'square',
  'squats',
  'stair-stepper',
  'star-2',
  'star-half',
  'star-topper',
  'star',
  'statue-of-liberty',
  'steam',
  'steering-wheel',
  'stethoscope',
  'sticker',
  'stock',
  'stop-circle',
  'stop',
  'stopwatch-2-off',
  'stopwatch-2',
  'stopwatch',
  'storage',
  'store-2',
  'store',
  'strikethrough',
  'stripe',
  'substack',
  'subtitle',
  'subtract',
  'sugar-coated-haws',
  'suitcase-2',
  'suitcase',
  'sun-2',
  'sun-cloudy',
  'sun-fog',
  'sun',
  'sunflower',
  'sunrise',
  'sunset',
  'surfboard',
  'surprise',
  'sweats',
  'swimming-pool',
  'swimming',
  'switch',
  'sword',
  'sydney-opera-house',
  't-shirt-2',
  't-shirt',
  'table-2',
  'table-3',
  'table',
  'tag-2',
  'tag-chevron',
  'tag',
  'taipei101',
  'taj-mahal',
  'tank',
  'target',
  'task-2',
  'task',
  'taurus',
  'teacup',
  'telegram',
  'telescope-2',
  'telescope',
  'temple-of-heaven',
  'tent',
  'terminal-ai',
  'terminal-box-ai',
  'terminal-box',
  'terminal',
  'terror',
  'test-tube',
  'tether-usdt',
  'text-2',
  'text-area',
  'text-color',
  'text-direction-left',
  'text-direction-right',
  'text',
  'textbox-ai',
  'textbox',
  'thermometer',
  'thought',
  'threads',
  'three-circles',
  'three-quarters-circle-dash',
  'thumb-down-2',
  'thumb-down',
  'thumb-up-2',
  'thumb-up',
  'thunderstorm',
  'ticket',
  'tiktok',
  'time-duration',
  'time',
  'timeline',
  'to-do',
  'toggle-left-2',
  'toggle-left',
  'toggle-right-2',
  'toggle-right',
  'toilet-paper',
  'tongue',
  'tool',
  'tornado-2',
  'tornado',
  'tower-crane',
  'tower',
  'toxophily',
  'toy-horse',
  'traffic-cone',
  'traffic-lights',
  'train-2',
  'train-3',
  'train-4',
  'train',
  'transfer-2',
  'transfer-3',
  'transfer-4',
  'transfer-horizontal',
  'transfer-vertical',
  'transfer',
  'transformation',
  'translate-2-ai',
  'translate-2',
  'translate',
  'tree-2',
  'tree-3',
  'tree-4',
  'tree',
  'trello-board',
  'trending-down',
  'trending-up',
  'triangle',
  'triumphal-arch',
  'trophy',
  'trouser',
  'truck',
  'trunk',
  'tunnel',
  'tv-1',
  'tv-2',
  'tv-tower',
  'twitch',
  'twitter',
  'typhoon',
  'tyre',
  'ubuntu',
  'ufo-2',
  'ufo',
  'umbrella-2',
  'umbrella',
  'unarchive',
  'underline',
  'unfold-horizontal',
  'unfold-vertical',
  'unhappy-dizzy',
  'unhappy',
  'union',
  'unlink-2',
  'unlink',
  'unlock',
  'up-small',
  'up',
  'upload-2',
  'upload-3',
  'upload',
  'usb-flash-disk',
  'usb',
  'usd-coin-usdc',
  'user-1',
  'user-2',
  'user-3',
  'user-4',
  'user-5',
  'user-add-2',
  'user-add',
  'user-edit',
  'user-follow-2',
  'user-follow',
  'user-forbid',
  'user-heart',
  'user-hide',
  'user-info',
  'user-lock',
  'user-pin',
  'user-question',
  'user-remove-2',
  'user-remove',
  'user-search',
  'user-security',
  'user-setting',
  'user-star',
  'user-visible',
  'user-warning',
  'user-x',
  'vector-bezier-2',
  'vector-bezier-3',
  'vector-bezier',
  'vector-group',
  'version',
  'vest',
  'vibe-coding',
  'viber-messenger',
  'video-ai',
  'video-camera-2',
  'video-camera',
  'video',
  'vip-1',
  'vip-2',
  'vip-3',
  'vip-4',
  'virgo',
  'virus',
  'visa',
  'vison-pro',
  'vkontakte',
  'voice-2',
  'voice',
  'volleyball',
  'volume-mute',
  'volume-off',
  'volume',
  'vscode',
  'vue',
  'walk',
  'wallet-2',
  'wallet-3',
  'wallet-4',
  'wallet-5',
  'wallet',
  'wardrobe-2',
  'wardrobe',
  'warm-up-2',
  'warm-up-3',
  'warm-up',
  'warning',
  'wash-machine',
  'wastebasket',
  'watch-2',
  'watch',
  'watering-can',
  'wave-hand',
  'wave',
  'web',
  'webhook',
  'wechat-miniprogram',
  'wechat-pay',
  'wechat',
  'weibo',
  'weightlifting',
  'wet',
  'whatsapp',
  'wheel',
  'wheelchair',
  'whistle',
  'whiteboard',
  'wifi-off',
  'wifi',
  'wind',
  'windows',
  'wine',
  'wineglass-2',
  'wineglass',
  'wiper',
  'world-2',
  'world',
  'wreath',
  'x-skew',
  'xbox',
  'xls',
  'xrp',
  'y-skew',
  'yahoo',
  'yinyang',
  'yoga',
  'youtube',
  'yuanbao',
  'za-sort-ascending-letters',
  'za-sort-descending-letters',
  'zazen',
  'zoom-in',
  'zoom-out',
] as const;

export type MingcuteLineIconKey = (typeof mingcuteLineIconKeys)[number];
